<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox1">
            <div class="item">
            <el-form-item label="成交时间:" prop="createTime">
              <el-date-picker
                  v-model="searchFrom.createTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="委托方:" prop="tenantName">
              <el-select  v-model="searchFrom.tenantName1"  placeholder="" filterable>
                <el-option v-for="val in WTlist" :label="val.tenantName" :value="val.tenantName" :key="val.tenantName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="承运方:" prop="carrierName">
              <el-select  v-model="searchFrom.carrierName1"  placeholder="" filterable>
                <el-option v-for="val in CYlist" :label="val.carriageName" :value="val.carriageName" :key="val.carriageName"></el-option>
              </el-select>
            </el-form-item>

            </div>
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                 <el-form-item >
                  <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
                </el-form-item>
                 <el-form-item>
                  <p class="margin0">总收入金额：<span class="red">{{tongji.allTotal}}</span>元</p>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
       <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
       <el-table-column prop="createTime"  min-width="170" :formatter="dateTimeFormat" label="成交时间"></el-table-column>
       <el-table-column property="publishPricingMethod" label="是否收款">
          <template scope="scope">{{scope.row.settlementStatus==1303?'是':'否'}}</template>
        </el-table-column>
        <el-table-column prop="businessNo"  min-width="240" :formatter="emptyFn" label="业务编号" show-overflow-tooltip></el-table-column>
       <el-table-column prop="tenantName"  min-width="220" :formatter="emptyFn" label="委托方"></el-table-column>
       <el-table-column prop="carrierName"  min-width="220" :formatter="emptyFn" label="承运方"></el-table-column>
        <el-table-column prop="totalAmount"  min-width="130" :formatter="emptyFn" label="收入金额(元)" show-overflow-tooltip></el-table-column>
        <el-table-column prop="dealWeight"  min-width="130" :formatter="emptyFn" label="支出金额(元)" show-overflow-tooltip>
           <template>0</template>
        </el-table-column>
        <el-table-column prop="totalAmount"  min-width="130" :formatter="emptyFn" label="利润(元)" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import {
  orderCarriageList,
  orderTenantList,
  upstreamSettlementList
} from '@/api/soc-customer'
export default {
  data () {
    return {
      title: '',
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        invoiceType: 3
      },
      total: 0,
      tongji: {},
      loading: false,
      WTlist: [],
      CYlist: [],
      isDisable: false,
      btnFlg: [],
      btnIdArr: ['004P003B000', '004P003B001', '004P003B002']
    }
  },
  created () {
    // this.btnFlg = getBtn(this.btnIdArr, '/systemSetup/address')
    orderCarriageList({ carriageType: 1 }).then(res => {
      this.CYlist = res
      if (res.length > 0) {
        this.CYlist.unshift({ carriageName: '全部', tenantCode: '' })
      }
    })
    orderTenantList().then(res => {
      this.WTlist = res
      if (res.length > 0) {
        this.WTlist.unshift({ tenantName: '全部', tenantCode: '' })
      }
    })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 导出
    exportFn () {
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.payServer + '/upstreamSettlement/incomeDetailsExportList',
        form,
        '收入明细'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      if (this.searchFrom.tenantName1 == '全部') {

      } else {

      }
      this.$set(this.searchFrom, 'tenantName', this.searchFrom.tenantName1 == '全部' ? '' : this.searchFrom.tenantName1)
      this.$set(this.searchFrom, 'carrierName', this.searchFrom.carrierName1 == '全部' ? '' : this.searchFrom.carrierName1)
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      upstreamSettlementList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        this.tongji = res.map
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        invoiceType: 3
      }
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 1002:
          return '待竞价'
        case 1101:
          return '竞价中'
        case 1102:
          return '待比价'
        case 1203:
          return '竞价成功'
        case 1202:
          return '竞价失败'
        case 1201:
          return '已作废'
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox1 .el-date-editor{
  width: 350px!important;
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 14px;
    color: #409eff;
  }
  .danwei1 {
    position: absolute;
    right: 14px;
    color: white;
    padding: 7px 4px;
  }
}
/deep/.inpBox1 .el-input__inner {
    width: 180px;
}
</style>
